<script setup lang="ts">
import type { IAnalytics } from '~~/types/local_types';

defineProps({
  analytics: {
    type: Object as () => IAnalytics,
    default: null,
  },
});

const googleFavUrl = 'https://www.google.com/preferences/source?q=eenvandaag';
</script>

<template>
  <Button
    icon="eenvandaag-general:google"
    label="Maak favoriet"
    variant="secondary"
    target="_blank"
    :analytics="analytics"
    :to="googleFavUrl"
    >Maak Favoriet</Button
  >
</template>

<style scoped lang="postcss"></style>
